var React = require('react');

function WaveTop (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0 0h1440v21.2l-150.4 15.5a3000 3000 0 0 1-589.2 2.5L548 24.8a3000 3000 0 0 0-435.8-9.4L0 21.2V0Z","fill":"#fff"}));
}

WaveTop.defaultProps = {"width":"1440","height":"53","viewBox":"0 0 1440 53","fill":"none"};

module.exports = WaveTop;

WaveTop.default = WaveTop;
